import { prefixer, createApiConsts } from '../../Helpers/constants'
import { SCREEN_RECORDING_QUALITY } from '../../App/ApplicationManagement/QmGlobalSettings/qmGlobalSettings.helpers'

const createPrefixedConst = prefixer('DESKTOP_PROPERTIES')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const GET_DESKTOP_PROPERTIES = createPrefixedApiConsts('GET_DESKTOP_PROPERTIES')
export const PUT_DESKTOP_PROPERTIES = createPrefixedApiConsts('PUT_DESKTOP_PROPERTIES')

export const DESKTOP_PROPERTIES = {
  WILL_DISPLAY_CONTACT_IN_USER_TIMEZONE: 'willDisplayContactInUserTimezone',
  EXTEND_SCREEN_RECORDING: 'extendScreenRecording',
  END_SCREEN_ON_NEW_CALL: 'EndScreenOnNewCall',
  SCREEN_RECORDING_BITRATE: 'screenRecordingBitrate',
  SCREEN_RECORDING_CPU: 'screenRecordingCPU',
  SCREEN_RECORDING_FPS: 'screenRecordingFPS',
  TALKOVER_THRESHOLD: 'talkoverThreshold',
  SILENCE_THRESHOLD: 'silenceThreshold',
  RETENTION_MAX_RECYCLE_BIN_VALUE: 'retentionMaxRecycleBinValue',
  RETENTION_MAX_RECYCLE_BIN_UNIT: 'retentionMaxRecycleBinUnit',
  RETENTION_ACTUAL_RECYCLE_BIN_VALUE: 'retentionActualRecycleBinValue',
  RETENTION_ACTUAL_RECYCLE_BIN_UNIT: 'retentionActualRecycleBinUnit',
  USE_FIRST_CALLING: 'useFirstCalling',
  USE_FIRST_CALLED: 'useFirstCalled',
  USE_RTP: 'useRTP',
  SIP_FILTER_PORT: 'sipFilterPort',
  MAX_CONTACT_DURATION_MS: 'maxContactDurationMs',
  MIN_CONTACT_DURATION_MS: 'minContactDurationMs',
  STUN_TURN_SERVER_ID: 'stunTurnServerId',
  RETENTION_ACTUAL_RECONCILIATION_DATA_UNIT: 'retentionActualReconciliationDataUnit',
  RETENTION_ACTUAL_RECONCILIATION_DATA_VALUE: 'retentionActualReconciliationDataValue',
  RETENTION_MAX_RECONCILIATION_DATA_UNIT: 'retentionMaxReconciliationDataUnit',
  RETENTION_MAX_RECONCILIATION_DATA_VALUE: 'retentionMaxReconciliationDataValue',
  RETENTION_ACTUAL_ROOT_RECORDING_UNIT: 'retentionActualRootRecordingUnit',
  RETENTION_ACTUAL_ROOT_RECORDING_VALUE: 'retentionActualRootRecordingValue',
  RETENTION_ACTUAL_ROOT_SCREEN_RECORDING_UNIT: 'retentionActualRootScreenRecordingUnit',
  RETENTION_ACTUAL_ROOT_SCREEN_RECORDING_VALUE: 'retentionActualRootScreenRecordingValue',
  RETENTION_ACTUAL_NON_CALL_UNIT: 'retentionActualNonCallUnit',
  RETENTION_ACTUAL_NON_CALL_VALUE: 'retentionActualNonCallValue',
  RETENTION_MAX_NON_CALL_UNIT: 'retentionMaxNonCallUnit',
  RETENTION_MAX_NON_CALL_VALUE: 'retentionMaxNonCallValue',
  RETENTION_MAX_ROOT_RECORDING_UNIT: 'retentionMaxRootRecordingUnit',
  RETENTION_MAX_ROOT_RECORDING_VALUE: 'retentionMaxRootRecordingValue',
  RETENTION_DURATION_MAX_VOICE_VALUE: 'retentionDurationMaxVoiceValue',
  RETENTION_DURATION_MAX_VOICE_UNIT: 'retentionDurationMaxVoiceUnit',
  SCREEN_RECORDING_PRIORITY: 'ScreenRecordingPriority',
  TENANT_TIME_ZONE: 'timeZone',
  SHARED_MEDIA_DIRECTORY: 'sharedMediaDirectory',
  SHARED_MEDIA_DIRECTORY_USER: 'sharedMediaDirectoryUser',
  SHARED_MEDIA_DIRECTORY_PASSWORD: 'sharedMediaDirectoryPassword',
} as const

export const SCREEN_RECORDING_PRIORITY = {
  NO_PRIORITY: 'NO_PRIORITY',
  STANDARD_ENDPOINT: 'STANDARD_ENDPOINT',
  THIN_CLIENT_ENDPOINT: 'THIN_CLIENT_ENDPOINT',
} as const

export const SCREEN_RECORDING_BITRATE = {
  [SCREEN_RECORDING_QUALITY.GOOD]: '400',
  [SCREEN_RECORDING_QUALITY.BETTER]: '600',
  [SCREEN_RECORDING_QUALITY.BEST]: '800',
} as const

export const SCREEN_RECORDING_CPU = {
  [SCREEN_RECORDING_QUALITY.GOOD]: '0',
  [SCREEN_RECORDING_QUALITY.BETTER]: '1',
  [SCREEN_RECORDING_QUALITY.BEST]: '2',
} as const
